import { LoaddingService } from './../../providers/loadding.service';
import { ChaseOrderDetailPage } from './chaseorderdetail';
import { ChaseSearchPage } from './search';
import { PageDefault } from './../PageDefault';
import { AppConfig } from './../../app/app.config';
import { VrService } from './../../services/vr.service';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

/**
 * Generated class for the VrchasereportPage page.
 * VR追号记录列表
 * TQQ 2018-01-26
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
    selector: 'page-vrgamereport',
    templateUrl: 'vrchasereport.html',
})
export class VrchasereportPage {

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private vrService: VrService,
        private config: AppConfig,
        private modalCtrl: ModalController,
        private loading: LoaddingService
    ) { }

    states = [
        { code: 0, name: '进行中' },
        { code: 1, name: '完成' },
        { code: 2, name: '中后停' },
        { code: 3, name: '延迟开奖停止' }
    ];
    paras = {
        userName: this.config.getCurrentUser().UserName,
        state: '',
        startDate: PageDefault.endNowDate(),
        endDate: PageDefault.endDate(),
        pageIndex: 1,
        pageSize: PageDefault.PageSize()
    };
    modelList = [];
    hasmore = false;
    isHave = true;

    ionViewDidLoad() {
        this.getBetChaseReport();
    }

    //下拉重新加载
    //TQQ 2018-01-26
    doRefresh(refresher) {
        this.paras.pageIndex = 1;
        this.getBetChaseReport().then(() => {
            refresher.complete();
        });
    }

    //上拉获取下一页信息
    //TQQ 2018-01-26
    doInfinite(infiniteScroll) {
        this.paras.pageIndex++;
        this.getBetChaseReport().then(() => {
            infiniteScroll.complete();
        });
    }

    //查询条件
    //TQQ 2018-01-26
    presentFilter() {
        let modal = this.modalCtrl.create(ChaseSearchPage, { paras: this.paras, states: this.states });
        modal.present();
        modal.onWillDismiss(data => {
            if (data) {
                this.paras = data;
                this.getBetChaseReport();
            }
        });
    }

    //获取vr追号信息
    //TQQ 2018-01-26
    getBetChaseReport() {
        let load = this.loading.showLoding();
        return this.vrService.getBetChaseReport(this.paras).then(s => {
            if (s.List != null) {
                if (this.paras.pageIndex == 1) {
                    this.modelList = [];
                    this.modelList = s.List;
                    if (s.List.length < s.PageCount) {
                        this.hasmore = true;
                    } else {
                        this.hasmore = false;
                    }
                } else {
                    this.modelList = this.modelList.concat(s.List);
                    if (this.modelList.length < s.PageCount) {
                        this.hasmore = true;
                    }
                    else {
                        this.paras.pageIndex = 1;
                        this.hasmore = false;
                    }
                }
            } else {
                this.modelList = [];
            }
            if (this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
            this.loading.closeLoading(load);
        }).catch(() => {
            this.loading.closeLoading(load);
        });
    }

    //vr订单详情
    //TQQ 2018-01-26
    getOrderDetail(item) {
        let modal = this.modalCtrl.create(ChaseOrderDetailPage, { order: item, states: this.states, userName: this.paras.userName });
        modal.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/vrchasereport/vrchasereport.ts